import { useCallback } from 'react';
import { useGrfqService } from '#/unified-rfqs/contexts/grfqs';
import { AuctionType } from '#/unified-rfqs/entities/shared';
import { useUnifiedRfqsService } from '#/unified-rfqs/contexts/unified-rfqs';
import { GrfqTradeTape } from '#/unified-rfqs/entities/grfq/domain';
import { useMarketPayloadCreator } from './shared';

export default function useCreateMarketFromObTrade() {
  const { selectById } = useUnifiedRfqsService();
  const grfqService = useGrfqService();
  const createPayload = useMarketPayloadCreator();

  const cb = useCallback(
    async (
      trade: GrfqTradeTape,
      onError: (msg: string) => void,
      auctionType: AuctionType = 'OB',
    ) => {
      const storedOb = selectById(trade.rfq_id);
      if (storedOb != null) {
        return createPayload(storedOb, auctionType);
      }

      const resp = await grfqService.getRfq({ rfqId: trade.rfq_id });
      if (!resp.ok) {
        onError(resp.message);
        return;
      }
      return createPayload(resp.data, auctionType);
    },
    [createPayload, grfqService, selectById],
  );

  return cb;
}
